import React, { useState } from "react";
import Sidebar from "./components/Sidebar/Sidebar";
import { ProjectProvider } from "./context/ProjectContext";
import DesignCanvas from "./components/Canvas/DesignCanvas";
import BrushSize from "./components/Toolbar/BrushSize";
import Toolbar from "./components/Toolbar/Toolbar";

export default function App() {
  const [sidebarHidden, setSidebarHidden] = useState(false);

  return (
    <ProjectProvider>
      <div style={{ display: "flex", height: "100vh" }}>
{!sidebarHidden && (
  <div
    style={{
      flexShrink: 0,
      height: "100vh",
      overflow: "hidden",
      display: "flex",
      minHeight: 0,
    }}
  >
    <Sidebar />
  </div>
)}

   <div style={{ flex: 1, padding: 12, overflow: "auto" }}>
  <div style={{ marginBottom: 6 }}>
    <Toolbar
      leadingControls={
        <>
          <BrushSize />

          <button
            type="button"
            onClick={() => setSidebarHidden(!sidebarHidden)}
            className={`sidebar-toggle ${sidebarHidden ? "active" : ""}`}
          >
            {sidebarHidden ? "☰ Show Sidebar" : "✕ Hide Sidebar"}
          </button>
        </>
      }
    />
  </div>
          <DesignCanvas />
        </div>
      </div>
    </ProjectProvider>
  );
}